import { ID } from "@datassential/platform-ui-lib";

export enum WorkspaceEnum {
    Manufacturers = 'manufacturers',
    Operators = 'operators',
    Sales = 'sales',
    Pricing = 'pricing',
}

export const WORKSPACE_ENUM_VALUES: WorkspaceEnum[] = Object.values(WorkspaceEnum) as WorkspaceEnum[];

export const CHAIN_ENABLED_WORKSPACES: WorkspaceEnum[] = [WorkspaceEnum.Operators];

export interface AvailableWorkspace {
    id: WorkspaceEnum;
    workspaceId: number;
    name: string;
    displayName: string;
    canRead: boolean;
    isActive: boolean;
    isDefault: boolean;
}

export interface AvailableChain {
    id: ID;
    name: string;
    isDefault: boolean;
}

export function isWorkspaceAccessible(workspace: AvailableWorkspace): boolean {
    return workspace.canRead && workspace.isActive;
}

export function isWorkspaceEnum(value: WorkspaceEnum | null) {
    return typeof value === 'string' && WORKSPACE_ENUM_VALUES.includes(value);
}

export function parseWorkspaceId(value: string | null): WorkspaceEnum | null {
    return value && isWorkspaceEnum(value as WorkspaceEnum) ? (value as WorkspaceEnum) : null;
}

export function parseChainId(value: string | null): ID | null {
    if (value === null || value === '' || value === 'null') return null;

    const trimmed = String(value).trim();
    if (trimmed === '' || trimmed === 'null') return null;

    const num = Number(trimmed);

    return Number.isInteger(num) && num > 0 ? num : null;
}
